import { Box, Typography } from "@mui/material";
import React from "react";

function NCXFormLabel(props) {
  const fieldPropsBox = {
    textAlign: props?.field?.properties?.alignment,
  };

  const fieldPropsText = {
    fontSize: props?.field?.properties?.fontSize,
    fontWeight: props?.field?.properties?.fontWight,
  };

  return (
    <Box
      key={props?.field._id}
      sx={{ marginBottom: "16px", width: "100%", ...fieldPropsBox }}
    >
      <Typography sx={fieldPropsText}>
        {props?.field?.properties?.label}
      </Typography>
    </Box>
  );
}

export default NCXFormLabel;
